import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { fundingSourceSetting } from '~/models/administration/fundingSourceSetting';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class FundingSourceSettingsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminAssets);
    }

    getFundingSourceSettings() {
        return this.http.get<fundingSourceSetting>(this._url());
    }

    updateFundingSourceSettings(model: any) {
        return this.client.put(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/FundingSourceSettings${v}`);
    }
}
